import React from 'react';
import './App.css';
import Display from './Display.jsx';
import Digit from './Digit.jsx';
import Operator from './Operator.jsx';
import Reset from './Reset.jsx';

var digits = ["1","2","3","4","5","6","7","8","9","0","."];
var operators = ["+","-","*","/","="];


export default class App extends React.Component {
  constructor (props){
    super(props);
    this.state = {
       currentChar: "",
       concatChar: "",
       result: ""
    }
    this.setDigit = this.setDigit.bind(this);
    this.setOperator = this.setOperator.bind(this);
    this.reset = this.reset.bind(this);
    this.errorMessage = this.errorMessage.bind(this);
    this.errorMessagePart = this.errorMessagePart.bind(this);
    this.errorMessageTooLong = this.errorMessageTooLong.bind(this);
  }

  
  setDigit(digit){
    console.log(this.state.concatChar.length)
    
    if (this.state.concatChar.length + this.state.result.toString().length > 29) this.errorMessageTooLong();
  this.state.result ?
  this.setState({
    currentChar: digit,
    concatChar: digit,
    result: ""
  }) :
  digit === "0" && !(/[+\-*/\d]/.test(this.state.currentChar)) ?
  this.errorMessage() :
  this.setState(state => ({
      concatChar: state.concatChar+digit,
      currentChar: digit
    }) 
  ) 
}

setOperator(op){
  console.log(this.state.concatChar.length)
  console.log(this.state.result.toString().length)
  if (this.state.concatChar.length + this.state.result.toString().length > 27) return this.errorMessageTooLong();
  /\d/.test(this.state.result) ?
                                op === "=" ? 
                                          
                                          (/\d/.test(this.state.currentChar)) ?
                                                     this.setState(state => ({
                                                        concatChar: state.result+(state.concatChar).match(/[+\-*/][\d+.]*\d+$/)[0] ,
                                                        result: eval(state.result+(state.concatChar).match(/[+\-*/][\d+.]*\d+$/)[0])
                                                                       }))    :

                                                     this.errorMessage()
                                           :
                                            this.setState( state => ({
                                                                      currentChar: op,
                                                                      concatChar: state.result+op,
                                                                      result: ""
                                                                     })) 
                                : 
                                op === "=" ?
                                    !/[+\-*/]/.test(this.state.concatChar) ?
                                      this.setState( state => ({
                                        concatChar: state.concatChar,
                                        currentChar: state.currentChar
                                      }))                                  :
                                               /\.{2}/.test(this.state.concatChar) ?
                                                                 this.errorMessage() 
                                                                                   :
                                                             /--/.test(this.state.concatChar) ?
                                                                        this.setState ( state => ({
                                                                                                  concatChar: state.concatChar.replace("--","+"),
                                                                                                 })) 
                                                                                              :           
                                                                        (/\d/.test(this.state.currentChar)) ?
                                                                                             this.setState ( state => ({
                                                                                                                        result: eval(state.concatChar),
                                                                                                                       }))               
                                                                                                            :
                                                                                             this.errorMessagePart() 
                                            :
                                        (!this.state.currentChar && op !== "-") ?
                                                                    this.errorMessagePart() 
                                                                                :
                                                                    this.setState(state => ({
                                                                                             concatChar: state.concatChar+op,
                                                                                             currentChar: op
                                                                                            }))
}

errorMessagePart(){
  this.setState(state => ({
    concatChar: " ERROR!! PICK A DIGIT OR MINUS SIGN ",
    currentChar: state.concatChar
}));
setTimeout(()=> this.setState(state => ({
  concatChar: state.currentChar,
  currentChar: ""
})),1000)
}
errorMessageTooLong(){
  this.setState(state => ({
    concatChar: " ERROR!! NUMBER TOO LONG ",
    currentChar: state.concatChar
}));
setTimeout(()=> this.setState(state => ({
  concatChar: state.currentChar,
  currentChar: ""
})),1000)
}


errorMessage(){
  this.setState(state => ({
    concatChar: " ERROR!! PICK A DIGIT OR MINUS SIGN ",
    currentChar: ""
}));
setTimeout(()=> this.setState(state => ({
  concatChar: "",
  currentChar: ""
})),1000)
}

reset(){
  this.setState({
    currentChar: "",
    concatChar: "",
    result: ""
  })

}
  render (){
    console.log(this.state.currentChar);
    console.log(this.state.concatChar);
    console.log(this.state.result)
    
    return (
      <div className="App">
          <div className="calc-container">
             <Display result = {this.state.result} currentChar={this.state.currentChar} concatChar={this.state.concatChar} />
              <div className="digits-ops-container">
                <div className="digits">
                    {digits.map ( dig => <Digit digit={dig} setDigit={this.setDigit}/>)}
                    <Reset reset={this.reset}/>
                </div>
               
                <div className="operators">
                    {operators.map ( op => <Operator operator={op} setOperator={this.setOperator}/>)}
                </div>
            </div>
          </div>
          <div className="sign">
            Calculator written and designed by Cesare Polonara
          </div>
      </div>
    )
  }
}